import { z } from 'zod';

export const pointSchema = z.object({
  x: z.number(),
  y: z.number(),
});

export type PointB = z.infer<typeof pointSchema>;
